/**
 * values to be used on 'email' form field for setting 'validation'
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const EMAIL_VALIDATION_TYPES = {
  SINGLE: 'single',
  DOUBLE: 'double',
};

const EMAIL_VALIDATION_TYPES_LIST = [
  { text: locale('Single Entry'), value: EMAIL_VALIDATION_TYPES.SINGLE },
  { text: locale('Double Entry'), value: EMAIL_VALIDATION_TYPES.DOUBLE },
];

const EMAIL_VALIDATION_TYPES_ALL = _.map(EMAIL_VALIDATION_TYPES_LIST, 'value');

export { EMAIL_VALIDATION_TYPES, EMAIL_VALIDATION_TYPES_LIST, EMAIL_VALIDATION_TYPES_ALL };

export default EMAIL_VALIDATION_TYPES;
